import React, { useEffect, useState } from "react";
import styles from "./Footer.module.css";
import SocialShare from "../SocialShare/SocialShare";
import Modal from "react-modal";
import { API, graphqlOperation } from "aws-amplify";
import { createSubscribersStaging } from "../../graphql/mutations";

import emailValidationReducer from "../../redux/reducers/emailValidationReducer";

const Footer = () => {
  // State variables
  const [windowWidth, setWindowWidth] = useState<number | undefined>(undefined);
  const [supportsUserAgentData, setSupportsUserAgentData] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isEmailAdded, setIsEmailAdded] = useState(false);
  const [isEmailEntered, setIsEmailEntered] = useState(true);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setWindowWidth(window.innerWidth);

      const handleResize = () => setWindowWidth(window.innerWidth);

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, []);

  // Effects
  useEffect(() => {
    setSupportsUserAgentData(!!navigator.userAgent);
    Modal.setAppElement("#root");
  }, []);

  // Event handlers
  const openModal = () => {
    if (!email) {
      setIsEmailEntered(false);
      return;
    }

    setIsEmailEntered(true);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const addEmail = async () => {
    closeModal();

    if (!email) {
      setIsEmailEntered(false);
      return;
    }

    setIsEmailEntered(true);

    const isValidEmail = emailValidationReducer(email);

    if (!isValidEmail) {
      setIsEmailValid(false);
      return;
    }

    setIsEmailValid(true);

    try {
      const result = await API.graphql(
        graphqlOperation(createSubscribersStaging, { input: { email } }),
      );

      if (result.data && result.data.createSubscribersStaging) {
        setEmail("");
        setIsEmailAdded(true);
      } else {
        console.error("Error creating subscriber:", result.errors);
      }
    } catch (error) {
      console.error("Error creating subscriber:", error);
    }
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.layoutFooter}>
        <div className={styles.footerSubscribe}>
          {/* <h3 className={styles.footerSubscribeTitle}>Stay in touch.</h3> */}
          {/* <div className={styles.inputContainer}>
            <input
              type="text"
              className={styles.subscribeEmail}
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              autoComplete={supportsUserAgentData ? "email" : undefined}
            />
            <button onClick={openModal} className={styles.subscribeButton}>
              Subscribe
            </button>
          </div> */}
          {windowWidth! >= 750 && <SocialShare />}
          {!isEmailValid && (
            <p className={styles.error}>
              This is not a valid email. Please re-enter.
            </p>
          )}
          {isEmailAdded && (
            <p className={styles.success}>Successfully added!</p>
          )}
          {!isEmailEntered && (
            <p className={styles.error}>No email address entered.</p>
          )}
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            contentLabel="Confirmation Modal"
            className={styles.subscriberModal}
            ariaHideApp={false}
          >
            <div className={styles.popupContainer}>
              <h2 className={styles.subscriberPopUpTitle}>
                Want to add your email address to our subscriber list so that
                you receive updates from The Hideaway Retreat?
              </h2>
              <div className={styles.buttonBar}>
                <button onClick={addEmail} className={styles.okButton}>
                  OK
                </button>
                <button onClick={closeModal} className={styles.cancelButton}>
                  Cancel
                </button>
              </div>
            </div>
          </Modal>
        </div>
        <div className={styles.contactInfo}>
          <img
            src="https://thehideawayretreat-storage-images234800-staging.s3.amazonaws.com/hideaway-retreat-logo.png"
            alt="logo"
            width={140}
          />
          <div className={styles.contactInfoItem}>
            <a href="tel:+18509392717" className={styles.linkFooter}>
              (850) 939-2717
            </a>
          </div>
          <div className={styles.contactInfoItem}>
            <a
              href="mailto:info@thehideawayretreat.com"
              className={styles.linkFooter}
            >
              info@thehideawayretreat.com
            </a>
          </div>
          <div className={styles.contactInfoItem}>
            <a
              href="https://www.google.com/maps/search/?api=1&query=9807+Navarre+Pkwy+Navarre+FL+32566"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.linkFooter}
            >
              9807 Navarre Pkwy Navarre, FL 32566
            </a>
          </div>
        </div>
      </div>

      {windowWidth! < 750 && <SocialShare />}
    </footer>
  );
};

export default Footer;
